import { Middleware } from 'redux';

import { RootState } from '..';
import { ReduxDispatch } from '../actions/thunkActions';
import { isPickedPointMovementRecipientActive } from '../selectors/pickingSelectors';
import { pickedPointMovementCleared } from '../slices/applicationSlice';

/**
 * Clears the pending picked point movement (see `beginPickedPointMovement`) once its recipient can no longer receive
 *   the point. If picking moved on or ended some other way, the pending movement is no longer meaningful.
 */
export const stalePickedPointMovementMiddleware: Middleware<{}, RootState, ReduxDispatch> =
  (store) => (next) => (action) => {
    const result = next(action);

    const state = store.getState();
    const pending = state.application.pendingPickedPointMovement;
    if (pending != null && !isPickedPointMovementRecipientActive(state, pending.recipient)) {
      store.dispatch(pickedPointMovementCleared());
    }

    return result;
  };
